import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useTheme } from '../context/ThemeContext';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ProcurementChart = ({ stats }) => {
  const { theme } = useTheme();

  // Konfigurasi warna berdasarkan tema
  const isDark = theme === 'dark';
  const textColor = isDark ? '#e5e7eb' : '#374151'; // gray-200 : gray-700
  const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

  // Data Metrik (Peraturan, Materi Pembelajaran, Jumlah Konsultasi, dan Respon SKM)
  const data = {
    labels: ['Peraturan', 'Materi Belajar', 'Konsultasi', 'Respon SKM'],
    datasets: [
      {
        label: 'Jumlah Saat Ini',
        // Data dinamis dari database (via endpoint /api/public-stats)
        data: [
          stats?.regulations || 0,
          stats?.courses || 0,
          stats?.consultations || 0,
          stats?.surveys || 0
        ],
        backgroundColor: [
          'rgba(249, 115, 22, 0.8)', // Orange
          'rgba(34, 197, 94, 0.8)',  // Green
          'rgba(59, 130, 246, 0.8)', // Blue
          'rgba(168, 85, 247, 0.8)'  // Purple (Respon SKM)
        ],
        borderColor: [
          'rgb(234, 88, 12)',
          'rgb(22, 163, 74)',
          'rgb(37, 99, 235)',
          'rgb(147, 51, 234)'
        ],
        borderWidth: 1,
        borderRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false, // Sembunyikan legenda agar lebih minimalis
      },
      title: {
        display: false,
      },
      tooltip: {
        backgroundColor: isDark ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.9)',
        titleColor: isDark ? '#fff' : '#000',
        bodyColor: isDark ? '#ccc' : '#333',
        borderColor: isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
        borderWidth: 1,
        padding: 12,
        cornerRadius: 8,
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { color: textColor },
        grid: { color: gridColor, drawBorder: false },
      },
      x: {
        ticks: { color: textColor, font: { weight: 'bold' } },
        grid: { display: false },
      },
    },
    animation: {
      duration: 2000,
      easing: 'easeOutQuart',
    }
  };

  return (
    <div style={{ width: '100%', height: '300px', position: 'relative' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default ProcurementChart;
